import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const getDealerEpd = (
  t: (key: string) => string
): FieldConfig[] => [
  {
    name: "id",
    label: "",
    type: "hidden",
  },
  {
    name: "operatorInn",
    label: t(`dealers.epdOperatorInn`),
    type: "text",
  },
  {
    name: "operatorName",
    label: t(`dealers.epdOperatorName`),
    type: "text",
  },
  {
    name: "edoAccountId",
    label: t(`dealers.epdEdoAccountId`),
    type: "text",
  },
  {
    name: "edoOperatorCode",
    label: t(`dealers.epdEdoOperatorCode`),
    type: "text",
  },
  {
    name: "signerCode",
    label: t(`dealers.epdSignerCode`),
    type: "text",
  },
  {
    name: "signerName",
    label: t(`dealers.epdSignerName`),
    type: "text",
  },
  {
    name: "signerPosition",
    label: t(`dealers.epdSignerPosition`),
    type: "text",
  },
  {
    name: "mchdGuid",
    label: t(`dealers.epdMchdGuid`),
    type: "text",
  },
  {
    name: "mchdValidFrom",
    label: t(`dealers.epdMchdValidFrom`),
    type: "date",
  },
  {
    name: "mchdUrl",
    label: t(`dealers.epdMchdUrl`),
    type: "text",
  },
  {
    name: "signerAuthorityCodes",
    label: t(`dealers.epdSignerAuthorityCodes`),
    type: "textarea",
  },
];
